<template>
  <div class="child-nav">
    <nav>
      <ul class="list child-list-right">
        <li v-for="(item, index) in routers"
            :key="index"
        >
          <router-link :to="{name: item.name}" exact>
            {{item.title}}
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        routers: [
          {name: 'home', title: 'TOP'},
          {name: 'products', title: 'Product Information'},
          {name: 'company', title: 'Company Profile'},
          {name: 'agency', title: 'Distributer List'},
          {name: 'news', title: 'Company News'},
          {name: 'stock', title: 'Stock Information'},
          {name: 'contact', title: 'Inquiry'}
        ]
      }
    },
    methods: {
    },
    created () {
      // console.log(this.$route.name)
    },
    watch: {
      '$route' (to, from) {
        // console.log(this.$route.path)
      }
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss" x-to="mobile" scoped>
  .child-nav {
    background: -webkit-linear-gradient(#fcfcfc 70%,#e9e9e9);
    background: -o-linear-gradient(#fcfcfc 70%,#e9e9e9);
    background: -moz-linear-gradient(#fcfcfc 70%,#e9e9e9);
    background: linear-gradient(#fcfcfc 70%,#e9e9e9);
    nav{
      max-width: 1200px;
      margin: auto;
      .child-list-right li{
        padding-left: 20px;
        a{
          padding: 10px 10px 15px;
          color: #333333;
          font-size: 14px;
          border-bottom: solid 5px transparent;
        }
        a:hover{
          border-bottom: solid 5px #c80000;
        }
        .active{
          border-bottom: solid 5px #c80000;
        }
        .router-link-active{
          border-bottom: solid 5px #c80000;
        }
      }
    }
    .line{
      height: 10px;
      margin-top: 5px;
    }
  }
  @media screen and (max-width: 767px){
    .j-header .child-nav {
      width: 100%;
      background: #e6e6e6;
      /*position: absolute;*/
      /*margin-top: 52px;*/
      /*z-index: 5;*/
      .list {
        li {
          display: block;
          font-weight: 600;
          margin-right: 0;
          vertical-align: middle;
          text-align: left;
          border-top: 1px solid #fff;
          padding-left: 10px;
          a{
            padding: 10px;
            border-bottom: none;
          }
          a:hover{
            border-bottom: none;
          }
          .active{
            border-bottom: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/Nav.vue